/**
 * This mixin is used to get paymentAmount, user, payments, credits, creditCardAmount, onlinePromotionApplied, existingDefaultPaymentMethod, existingSavedPaymentMethod
 * This mixin is used in the PaymentsForm.vue and ConsumerPaymentsForm.vue
 * This mixin is used in the SavedUserPayment.vue and SavedUserPaymentStripeButton.vue
 * This mixin is used in the UserCreditPayment.vue
 */
export default {
  data () {
    return {
      split: false
    }
  },
  computed: {
    user () {
      return this.order.user // Fetch the user for validate method
    },
    payments () {
      return _.filter(this.order.payments.data, payment => payment.amount >= 0 || payment.nonStripeCardPayment)
    },
    credits () {
      return _.filter(this.order.payments.data, payment => payment.amount < 0)
    },
    creditCardAmount () {
      return this.split ? this.splitAmount : this.order.remainingOwed
    },
    existingDefaultPaymentMethod () {
      return this.user?.defaultPaymentMethodId && _.find(this.order.payments.data, { type: 'card', subtype: 'saved', state: 'draft' })
    },
    existingSavedPaymentMethod () {
      return this.order?.savedPaymentMethodId && _.find(this.order.payments.data, { type: 'card', subtype: 'saved_tab', state: 'draft' })
    },
    placingOrRecaptcha () {
      return this.placing || this.recaptchaInProgress
    },
    buttonTextColor () {
      return this.$isColorDark(this.currentSite.primaryColor) ? 'white' : 'black'
    },
    hasRemainingOwed () {
      return this.order.remainingOwed > 0
    }
  },
  methods: {
    paymentAmount (existingAmount, maxAmount = null) {
      existingAmount ||= 0

      let amount = this.split ? this.splitAmount : this.order.remainingOwed
      // Always set a final max amount to ensure we don't take payment in excess of order total and available change
      const maxAmountPayable = this.order.remainingOwed + existingAmount
      const finalMaxAmount = !!maxAmount && maxAmount <= maxAmountPayable ? maxAmount : maxAmountPayable

      if (!this.split) {
        amount += existingAmount || 0
      }
      if (this.split) {
        return _.min([amount, finalMaxAmount - existingAmount])
      } else {
        return _.min([amount, finalMaxAmount])
      }
    }
  }
}
